import React from 'react';
import { ToastService } from '@iamsoftware/react-hooks';
import { useDataTable } from 'src/hooks/useAppDataTable';
import { useNavigate } from 'react-router-dom';
import { AgreementService } from '../../../../../service/AgreementService';
import { DocumentNameCell } from '../DocumentNameCell';

interface TrashTabProps {
    handleView: (rowData: any) => void;
    handleRestore: (rowData: any) => void;
    setReload?: (reloadFn: () => void) => void;
    headerActions?: React.ReactNode;
}

export const TrashTab: React.FC<TrashTabProps> = ({
    handleView,
    handleRestore,  
    setReload,
    headerActions
}) => {
    const navigate = useNavigate();
    const trashColumns: any[] = [
        {
            field: 'agreementName',
            header: 'Tên tài liệu',
            width: 220,
            matchMode: 'contains',
            dataType: 'custom' as const,
            customCell(rowData: any): any {
                return (
                    <DocumentNameCell
                        rowData={rowData}
                        onClick={() => handleView(rowData)}
                        title="Click để xem chi tiết"
                    />
                );
            }
        },
        { field: 'agreementNo', header: 'Mã tài liệu', width: 140, matchMode: 'contains' },
        { field: 'agreementTypeName', header: 'Loại tài liệu', width: 160, matchMode: 'contains' },
        // {
        //     field: 'statusDescription',
        //     header: 'Trạng thái',
        //     width: 120,
        //     dataType: 'custom' as const,
        //     customCell() {
        //         return <Tag value="Đã xóa" severity="danger" />;
        //     }
        // },
        // {
        //     field: 'mainContent',
        //     header: 'File ký',
        //     width: 220,
        //     dataType: 'custom' as const,
        //     customCell(row: any) {
        //         if (!row.mainContent) return <span className="text-gray-500">Chưa có file</span>;
        //         return (
        //             <div className="flex align-items-center gap-2">
        //                 <i className={`pi ${row.mainContent.contentType === 'application/pdf' ? 'pi-file-pdf' : 'pi-file-word'} text-xl`}></i>
        //                 <div>
        //                     <div className="font-medium">{row.mainContent.fileName}</div>
        //                     <small className="text-gray-500">{row.mainContent.contentType?.split('/')?.[1]?.toUpperCase()}</small>
        //                 </div>
        //             </div>
        //         );
        //     }
        // },
        { field: 'lastUpdatedStamp', header: 'Thời gian xóa', width: 160, dataType: 'date' }
    ];

    const mapListResult = (result: any) => {
        if (result.listData && Array.isArray(result.listData)) {
            result.listData = result.listData.map((item: any) => ({
                ...item,
                mainContent: item.mainFileName || item.mainContentType ? {
                    fileName: item.mainFileName,
                    contentType: item.mainContentType,
                    contentLocation: item.referenceContentLocation || item.mainContentLocation,
                    fileId: item.fileId || item.mainFileId || item.mainContentId,
                    googleFileId: item.fileId || item.mainFileId || item.mainContentId,
                    referenceFileId: item.referenceContentLocation
                } : null
            }));
        }
        const total = result.totalRecords ?? (result.listData || []).length;
        return {
            listData: result.listData || [],
            totalRecords: total,
            totalCount: total
        };
    };

    const { render: renderTrash, reloadLazyData: reloadTrash } = useDataTable({
        recordLabel: 'tài liệu trong thùng rác',
        headerActions,
        dataKey: 'agreementId',
        indexColumnWidth: 56,
        actionColumnWidth: 140,
        columns: trashColumns,
        getList: lazyLoadEvent => {
            return AgreementService.getAgreementList(lazyLoadEvent, 'AGT_DELETED').then(mapListResult);
        },
        initActions(items: Array<any>) {
            items?.forEach(item => {
                item.actions = [
                    { icon: 'pi pi-eye', title: 'Xem chi tiết', className: 'p-button-info', command: () => handleView(item) },
                    { icon: 'pi pi-refresh', title: 'Khôi phục', className: 'p-button-success', command: () => handleRestore(item) }
                ];
            });
        },
        originalProps: { scrollHeight: 'calc(100vh - 300px)' }
    });

    React.useEffect(() => {
        if (setReload) setReload(reloadTrash);
    }, [reloadTrash, setReload]);

    return (
        <div className="tai-lieu-ky-table">
            {renderTrash()}
        </div>
    );
};
